import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

// Regras Faturamento
export async function getRegrasFaturamento(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetRegrasFaturamento(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveRegrasFaturamento(regrasFaturamento) {
  try {
    const response = await authHttp().post(routes.urlPostRegrasFaturamento, regrasFaturamento)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateRegrasFaturamento(regrasFaturamento) {
  try {
    const response = await authHttp().put(
      routes.urlPutRegrasFaturamento(regrasFaturamento.id),
      regrasFaturamento,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Regras Faturamento
export async function getFaixaKm(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetFaixaKm(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveFaixaKm(faixaKm) {
  try {
    const response = await authHttp().post(routes.urlPostFaixaKm, faixaKm)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateFaixaKm(faixaKm) {
  try {
    const response = await authHttp().put(routes.urlPutFaixaKm(faixaKm.id), faixaKm)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Regras Faturamento
export async function getRegraFrete(tp_id, company_id) {
  try {
    const response = await authHttp().get(routes.urlGetRegraFrete(tp_id, company_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveRegraFrete(regraFrete) {
  try {
    const response = await authHttp().post(routes.urlPostRegraFrete, regraFrete)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateRegraFrete(tp_id, company_id, regraFrete) {
  try {
    const response = await authHttp().put(routes.urlPutRegraFrete(tp_id, company_id), regraFrete)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getValorFrete(delivery_id) {
  try {
    const response = await authHttp().get(routes.urlGetValorFrete(delivery_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postValorFreteConsolidado(deliveries_ids) {
  try {
    const response = await authHttp().post(routes.urlPostValorFreteConsolidado, { deliveries_ids })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
